import React, { useContext, useRef, useState } from 'react'
import { Col, Row, Card, Table, Spinner } from '@themesberg/react-bootstrap'
import { TableRow } from '../component/TableRow'
import Pagination from '../../../../components/Pagination'
import { Context } from '../Cart'
import ImagePreview from './image-preview/ImagePreview'
import CartDetailModal from '../component/CartDetailModal'

const _Table = () => {

  const { state, dispatch } = useContext(Context);

  const [modalImageShow, setModalImageShow] = useState(false)

  const selectedImageRef = useRef('')

  const previewTitleRef = useRef('')

  const [detailModalShow, setDetailModalShow] = useState(false)
  const [selectedCart, setSelectedCart] = useState(null)

  const showImagePreview = (title, image) => {
    previewTitleRef.current = title
    selectedImageRef.current = image
    setModalImageShow(true)
  }

  const handleShowCartDetail = (cart) => {
    setSelectedCart(cart)
    setDetailModalShow(true)
  }

  const filterIsDone = state.filter.isDone;
  const showImageColumns = state.activeTab === 'new' || filterIsDone === 1 || filterIsDone === -1;
  const showStatusColumn = state.activeTab === 'new' || filterIsDone === -1;
  const columnCount = 6 + (showStatusColumn ? 1 : 0) + (showImageColumns ? 1 : 0);

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Table responsive className="align-items-center table-bordered table-hover">
          <thead className='text-center'>
            <tr>
              <th scope="col">Mã đơn</th>
              <th scope="col">Người chơi</th>
              <th scope="col">Tổng tiền</th>
              <th scope="col">Số vé</th>
              {showStatusColumn && <th scope="col">Trạng thái</th>}
              {showImageColumns && <th scope="col">Hình ảnh</th>}
              <th scope="col">Thao tác</th>
              <th scope="col">Ngày tạo</th>
            </tr>
          </thead>
          <tbody>
            {state.loading ? (
              <tr>
                <td colSpan={columnCount} className="text-center py-5">
                  <div className="d-flex align-items-center justify-content-center gap-2">
                    <Spinner animation="border" size="sm" />
                    <span>Đang tải dữ liệu...</span>
                  </div>
                </td>
              </tr>
            ) : state.data.list && state.data.list.length > 0 ? (
              state.data.list.map((pv, index) => (
                <TableRow
                  handleShowImagePreview={showImagePreview}
                  handleShowCartDetail={handleShowCartDetail}
                  rIndex={index}
                  key={`table-keys-lottmekong-${pv.id}`}
                  filterIsDone={filterIsDone}
                  activeTab={state.activeTab}
                  {...pv}
                />
              ))
            ) : (
              <tr>
                <td colSpan={columnCount} className="text-center py-5 text-muted">
                  Không có dữ liệu
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <Card.Footer className='flex-row'>
          <Row className="align-items-center">
            <Col>
              <Pagination
                totalPage={state.data.totalPage || 0}
                currentPage={state.filter.page || 0}
                onPageChange={(i) => {
                  dispatch({
                    type: 'UPDATE_PAGE',
                    payload: i
                  })
                }}
              />
            </Col>
          </Row>
        </Card.Footer>
      </Card>
      <ImagePreview
        show={modalImageShow}
        title={previewTitleRef.current}
        image={selectedImageRef.current}
        onHide={() => setModalImageShow(false)}
      />
      <CartDetailModal
        show={detailModalShow}
        cart={selectedCart}
        onHide={() => setDetailModalShow(false)}
      />
    </>
  );
};

export default React.memo(_Table)
